import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    extrasAppliedInfo: [],
    offeredExtras: [],
    additionalExtras: [],
    upgradeQuotation: {
        confirmation: false,
        data: {
            pricePerDay: 1000,
            caracteristics: {
                passengers: 6,
                luggage: 4
            },
            description: "Chevrolet Suburban",
            smallImage: "upload/classes/jeep-grand-cherokee-or-similar_2022_05_27_10_24_40_.png",
            similar: "or Similar",
            classDescription: ''
        },
    },
    calculatedQuotation: {
        total: 0,
        rentalDays: 0,
        currencyInfo: {
            currencyId: 1,
            currencyCode: "MXN",
            currencyExchange: 0,
        },
        rate: {},
        calculatedRate: {},
        classes: {},
        taxes: {},
        extras: {},
        pickupInfo: {},
        dropoffInfo: {},
        reservationInfo: {},
        discounts: {}
    }
};

export const quotationSlice = createSlice({
    name: 'quotation',
    initialState,
    reducers: {
        resetQuotation: () => initialState,
        setInitializeQuotation: (state, { payload } ) => {
            state.calculatedQuotation = {
                ...payload.pricing,
                classes: payload.class,
                rentalDays: payload.rentalDays,
                currencyInfo: payload.currencyInfo,
                pickupInfo: payload.pickupInfo,
                dropoffInfo: payload.dropoffInfo,
                reservationInfo: payload.reservationInfo,
                pricePerDay: payload.pricing.rate.amount/payload.rentalDays
            };
            state.additionalExtras = payload.pricing.extras.breakdown;
            state.extrasAppliedInfo = payload.pricing.extras;
        },
        addExtraOfferToAdditional: (state, { payload }) => {
            const currentExtra = state.additionalExtras.find(x => x.code == payload.code);
            if (!!currentExtra) {
                currentExtra.itemQty = payload.itemQty;
            }else{
                const extra = state.offeredExtras.find(x => x.code == payload.code);
                state.additionalExtras.push({ ...extra, itemQty: payload.itemQty });
            }
        },
        removeExtraFromAdditional: (state, { payload }) => {
            const currentExtra = state.additionalExtras.find(x => x.code == payload.code);
            currentExtra.itemQty = payload.itemQty;
            if (payload.itemQty == 0 || !currentExtra.isCountable) {
                state.additionalExtras = state.additionalExtras.filter(x => x.code != payload.code);
            }
        },
        addAdditionalExtra: (state, { payload }) => {
            state.additionalExtras.push(payload);
        },
        removeAdditionalExtra: (state, { payload }) => {
            state.additionalExtras = state.additionalExtras.filter(x => x.id != payload);
        },
        setUpgradeQuotation: (state, { payload }) => {
            const upgradeInformation = payload;

            state.upgradeQuotation.data = {
                ...state.upgradeQuotation.data,
                pricePerDay: upgradeInformation.extra.price,
                caracteristics: {
                    passengers: upgradeInformation.class.passengers,
                    luggage: upgradeInformation.class.luggage
                },
                description: upgradeInformation.class.modelDesc,
                smallImage: upgradeInformation.class.urlSmallImage,
                similar: upgradeInformation.class.orSimilar,
                classDescription: upgradeInformation.class.classDesc,
            };
        },
        setUpgradeQuotationConfirmation: (state, { payload }) => {
            state.upgradeQuotation.confirmation = payload;
        },
        setOfferedExtras: (state, { payload }) => {
            state.offeredExtras = payload.map(x => ({...x, amount: x.price}));
        },
        setEditCalculatedQuotation: (state, { payload }) => {
            state.calculatedQuotation = {
                ...state.calculatedQuotation,
                taxes: payload.taxes,
                extras: payload.extras,
                total: payload.total,
                discounts: payload.discounts ?? [],
                rate: payload.rate,
                pricePerDay: payload.rate.subtotal/payload.rentalDays,
                currencyInfo: payload.currencyInfo
            }
        }
    }
});


// Action creators are generated for each case reducer function
export const {
    resetQuotation,
    setOfferedExtras,
    addExtraOfferToAdditional,
    removeExtraFromAdditional,
    removeUpgradeQuotation,
    setUpgradeQuotation,
    setUpgradeQuotationConfirmation,
    removeAdditionalExtra,
    addAdditionalExtra,
    setInitializeQuotation,
    setEditCalculatedQuotation
} = quotationSlice.actions;
